import React from 'react';

function StatusMessage({ color, icon, children }) {
  return (
    <div className="flex-grow p-8">
      <div className="w-full flex justify-center">
        <div className={`text-sm inline-flex items-center px-6 py-3 bg-${color}-100 text-${color}-800 rounded-lg`}>
          {icon}
          <span>{children}</span>
        </div>
      </div>
    </div>
  );
}

export default StatusMessage;